module.exports = __webpack_public_path__ + "static/media/Kadabra_gaussian2.ec27ff4d.png";